import { RCProperties } from '@spotify-internal/remote-config-properties';

// https://backstage.spotify.net/docs/remote-configuration-js-sdk/properties/#propertiesyaml
const rcProperties = {
  version: '1.0.0',
  properties: [
    {
      name: 'employee',
      description: 'S4A employee flag',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 's4x-understand-test-flag',
      description: 'Testing feature flag',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 's4x-understand-test-flag-two',
      description: 'Testing feature flag two',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'data-delay-alert',
      description:
        'Show an alert message in the app when there is a data delay.',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'audience-source-of-streams-benchmarking',
      description:
        'New source of streams chart with benchmarking on artist audience page.',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'alohomora-experiments',
      description: 'Alohomora experiment flag',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'alohomora-frontdoor-onboarding',
      description: 'Alohomora flag for front door onboarding flow',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'buyer-experience-campaigns',
      description: 'Buyer Experience campaigns feature flag',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'buyer-experience-admin',
      description: 'Buyer Experience admin tools feature flag',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 's4a-hype-campaigns',
      description: 'Allows an employee to manage HYPE campaigns',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'canvas-in-maintenance',
      description: 'Denotes the Canvas feature is under maintenance',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'canvas-terms-translation',
      description: 'Allows the user to select language for Canvas terms',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'storylines-creation',
      description: 'Allows a user to upload Storylines to songs',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 's4a-pro-pay',
      description: "Display an organization's stored payment method",
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'analytics-migration-onboarding',
      description:
        'Display an onboarding announcement for new Label users of S4A',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 's4a-web-profile-1p-rollout',
      description: 'Give label teams access to S4A web profile',
      boolSpec: { default: false },
    },
    {
      name: 's4a-web-profile-contextual-activity-feed',
      description: 'Show contextual activity feed on S4A web profile page',
      boolSpec: { default: false },
    },
    {
      name: 's4a-web-profile-artist-fundraising-pick-self-serve',
      description:
        'Moving Artist Fundraising Pick management to Profile and adding read, update and delete capabilities',
      boolSpec: { default: false },
    },
    {
      name: 'sa-sunset',
      description: 'Tri-state enum to represent three sunset states',
      enumSpec: {
        default: 'off',
        values: ['off', 'pre-sunset', 'post-sunset'],
      },
    },
    {
      name: 'audience-country-filters',
      description: 'Country filters on the Audience section',
      boolSpec: {
        default: false,
      },
    },
    {
      name: 'qualaroo-survey',
      description: 'Displays qualaroo survey for user',
      boolSpec: { default: false },
    },
    {
      name: 's4a-web-profile-artist-fundraising-pick-nz-latam-tr',
      description:
        'Enables new Artist Fundraising Pick payment platform partners for New Zealand, Latin America, and Turkey',
      boolSpec: { default: false },
    },
    {
      name: 'use-artist-graphql',
      description: 'Enable graphql endpoint for useArtist hook',
      boolSpec: { default: false },
    },
    {
      name: 'artist-access-instagram-verification',
      description:
        'Enable use of Instagram as a verification method when trying to access an artist',
      boolSpec: { default: false },
    },
  ],
} as const;

export const properties: RCProperties = {
  ...rcProperties,
  properties: rcProperties.properties.map(
    // Mapping creates a new array, which is mutable (instead of immutable via
    // the use of `as const`), and can then be compared to an array of
    // RCProperties using a type hint (as ...). This is just a little easier
    // than writing/maintaining a Mapped Type helper to unfreeze the `as const`
    // immutable type, while also retaining some type-safety (an alternative is
    // to use `as unknown` but that would abort all type checking of the initial
    // object).
    p => p,
  ) as RCProperties['properties'],
};

// Group the Specs by their value type (bool, int, enum) for use in the hooks
type RCPropertySpecs = typeof rcProperties['properties'][number];
export type MrktWebBoolRCPropertySpecs = Extract<
  RCPropertySpecs,
  { boolSpec: any }
>;
export type MrktWebEnumRCPropertySpecs = Extract<
  RCPropertySpecs,
  { enumSpec: any }
>;
export type MrktWebIntRCPropertySpecs = Extract<
  RCPropertySpecs,
  { intSpec: any }
>;
